// extracted by mini-css-extract-plugin
module.exports = {"lazyImage":"_2lOkxN5","silver":"_1ZUHyvd"};